module.exports = require('./lib/axios');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.0.14.0@axios/index.js
 ** module id = 251
 ** module chunks = 0
 **/